import { SectionCards } from "@/components/section-cards";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import Orders from "@/orders/orders";
import { ScoreByArticle } from "@/components/charts/score-by-article";
import { TrendQualityScore } from "@/components/charts/trend-quality-score";
import { DashboardControls } from "@/components/dashboard-controls";
import { useLocalization } from "@/context/localization-context";

export default function BranchDashboard() {
  const { t } = useLocalization();

  return (
    <div className="flex flex-1 flex-col overflow-auto">
      <div className="@container/main flex flex-1 flex-col gap-2">
        <div className="flex justify-end px-4 pt-4 lg:px-6 md:pt-6">
          <DashboardControls />
        </div>

        <div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6">
          <SectionCards />

          <div className="grid grid-cols-1 gap-4 px-4 lg:px-6 xl:grid-cols-2">
            <ScoreByArticle />
            <TrendQualityScore />
          </div>

          <div className="app-layout gap-4 px-4 lg:px-6">
            <Card>
              <CardHeader>
                <CardTitle>{t("dashboard.orders")}</CardTitle>
              </CardHeader>
              <CardContent>
                <Orders
                  getLink={(path) => `/orders/${path}`}
                  useDashboardDateRange={true}
                />
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}
